function a(r) {
  var e = r.images;
  return e ? '<drawing r:id="rId1"/>' : "";
}
export {
  a as default
};
//# sourceMappingURL=index.es270.js.map
